import { Capacitor } from "@capacitor/core";
import { Clipboard as CapacitorClipboard } from "@capacitor/clipboard";

/**
 * Whether clipboard text reading is supported in the current environment.
 * Mirrors the behavior used by AddContentModal.
 */
export function canReadClipboardText(): boolean {
  return (
    Capacitor.isNativePlatform() ||
    (typeof navigator !== "undefined" && typeof navigator?.clipboard?.readText === "function")
  );
}

/**
 * Read clipboard text (web + Capacitor native).
 * Returns null when unavailable or empty.
 */
export async function readClipboardText(): Promise<string | null> {
  if (Capacitor.isNativePlatform()) {
    const result = await CapacitorClipboard.read();
    return result.value || null;
  }

  if (typeof navigator !== "undefined" && typeof navigator?.clipboard?.readText === "function") {
    return await navigator.clipboard.readText();
  }

  return null;
}

